export { default } from "./src/graph-paper-reveal";
